document.addEventListener("DOMContentLoaded", function () {
	// --- 1. GALERIA DE FOTOS DO PRODUTO ---
	const galleryContainer = document.querySelector(".atq-photo-container");
	const mainImage = document.getElementById("mainProductImage");
	const mainPrevBtn = document.getElementById("mainImagePrev");
	const mainNextBtn = document.getElementById("mainImageNext");
	const mediaArray = [];

	function updateMainImage(index) {
		if (index < 0 || index >= mediaArray.length) return;
		const targetMedia = mediaArray[index];
		if (mainImage && targetMedia) {
			mainImage.style.opacity = "0.3";
			setTimeout(() => {
				mainImage.src = targetMedia.url;
				mainImage.setAttribute("data-media-id", targetMedia.id);
				mainImage.setAttribute("data-current-index", index);
				mainImage.style.opacity = "1";
			}, 150);

			const thumbListItems = galleryContainer
				? galleryContainer.querySelectorAll(".atq-thumb-item")
				: [];
			thumbListItems.forEach((li) => li.classList.remove("is-active"));
			if (thumbListItems[index]) {
				thumbListItems[index].classList.add("is-active");
			}
		}
	}

	if (galleryContainer) {
		const track = galleryContainer.querySelector(
			".atq-product-thumbs__track"
		);
		const thumbItems = galleryContainer.querySelectorAll(
			".atq-product-thumbs__item"
		);
		const thumbListItems =
			galleryContainer.querySelectorAll(".atq-thumb-item");
		const prevBtn = galleryContainer.querySelector(
			".atq-thumbs-carousel-wrapper .atq-arrows-thumb:first-child"
		);
		const nextBtn = galleryContainer.querySelector(
			".atq-thumbs-carousel-wrapper .atq-carousel-btn.atq-next-btn"
		);

		let currentPosition = 0;
		const visibleThumbs = parseInt(window.number_of_thumb) || 4;
		const gap = 10;

		thumbItems.forEach((thumb, index) => {
			mediaArray.push({
				id: thumb.getAttribute("data-media-id"),
				url: thumb.getAttribute("href"),
				index: index,
			});
		});

		thumbItems.forEach((thumb, index) => {
			thumb.addEventListener("click", function (e) {
				e.preventDefault();
				updateMainImage(index);
			});
		});

		if (mainPrevBtn && mainNextBtn) {
			mainNextBtn.addEventListener("click", function () {
				let currentIndex =
					parseInt(mainImage.getAttribute("data-current-index")) || 0;
				let nextIndex = currentIndex + 1;
				if (nextIndex >= mediaArray.length) nextIndex = 0;
				updateMainImage(nextIndex);
			});

			mainPrevBtn.addEventListener("click", function () {
				let currentIndex =
					parseInt(mainImage.getAttribute("data-current-index")) || 0;
				let prevIndex = currentIndex - 1;
				if (prevIndex < 0) prevIndex = mediaArray.length - 1;
				updateMainImage(prevIndex);
			});
		}

		if (track && thumbListItems.length > visibleThumbs) {
			function moveCarousel(direction) {
				const itemWidth = thumbListItems[0].offsetWidth + gap;
				const maxScroll =
					(thumbListItems.length - visibleThumbs) * itemWidth;

				if (direction === "next") {
					currentPosition += itemWidth;
					if (currentPosition > maxScroll) currentPosition = maxScroll;
				} else {
					currentPosition -= itemWidth;
					if (currentPosition < 0) currentPosition = 0;
				}

				track.style.transform = `translateX(-${currentPosition}px)`;
				updateButtonsState(maxScroll);
			}

			if (nextBtn)
				nextBtn.addEventListener("click", () => moveCarousel("next"));
			if (prevBtn)
				prevBtn.addEventListener("click", () => moveCarousel("prev"));

			function updateButtonsState(maxScroll) {
				if (prevBtn)
					prevBtn.style.opacity = currentPosition <= 0 ? "0.3" : "1";
				if (nextBtn)
					nextBtn.style.opacity =
						currentPosition >= maxScroll ? "0.3" : "1";
			}

			updateButtonsState(
				(thumbListItems.length - visibleThumbs) *
					(thumbListItems[0].offsetWidth + gap)
			);
		} else {
			if (prevBtn) prevBtn.style.display = "none";
			if (nextBtn) nextBtn.style.display = "none";
		}
	}

	// --- 2. ATUALIZAÇÃO DE VARIÁVEIS (PREÇO, SKU, ESTOQUE, DISPONIBILIDADE) ---
	const variantSelect = document.getElementById("productSelect");

	function updateATQVariantDetails(selectedOption) {
		if (!selectedOption) return;

		const variantId = selectedOption.value;
		const invData = window.variantInventories
			? window.variantInventories[variantId]
			: null;

		// 1. Preço
		const variantPrice =
			selectedOption.getAttribute("data-price") ||
			(invData ? invData.price : "");
		const priceElement = document.getElementById("atq-product-price");
		if (priceElement && variantPrice) {
			priceElement.textContent = variantPrice;
		}

		// 2. SKU
		const variantSku =
			selectedOption.getAttribute("data-sku") ||
			(invData ? invData.sku : "");
		const skuElement = document.getElementById("atq-product-sku");
		const skuWrapper =
			document.getElementById("atq-sku-wrapper") ||
			(skuElement ? skuElement.closest(".atq-product-box__sku") : null);
		if (skuElement) {
			if (variantSku && variantSku.trim() !== "") {
				skuElement.textContent = variantSku;
				if (skuWrapper) skuWrapper.style.display = "block";
			} else {
				if (skuWrapper) skuWrapper.style.display = "none";
			}
		}

		// 3. Estoque e Mensagens de Disponibilidade
		const rawQty = selectedOption.getAttribute("data-inventory-quantity");
		const qty = invData
			? invData.inventory_quantity
			: rawQty !== null
			? parseInt(rawQty)
			: 0;
		const policy = invData
			? invData.inventory_policy
			: selectedOption.getAttribute("data-inventory-policy") || "";
		const rawAvailable = selectedOption.getAttribute("data-available");
		const isAvailable = invData
			? invData.available
			: rawAvailable === "true" || rawAvailable === true;

		const qtyBar = document.getElementById("atq-qty-bar");
		const qtyVal = document.getElementById("atq-quantity");
		const progressWrap = document.getElementById("atq-progress-wrapper");
		const stockMsg = document.getElementById("atq-stock-message");

		if (qtyVal) qtyVal.textContent = qty;

		if (isAvailable && qty > 0) {
			if (qtyBar) qtyBar.style.display = "";
			if (progressWrap) progressWrap.style.display = "";
			if (stockMsg) stockMsg.innerHTML = "";
		} else if (policy === "continue") {
			if (qtyBar) qtyBar.style.display = "none";
			if (progressWrap) progressWrap.style.display = "none";
			if (stockMsg)
				stockMsg.innerHTML =
					'<p class="atq-availability-quantity">This product is available on backorder</p>';
		} else {
			if (qtyBar) qtyBar.style.display = "none";
			if (progressWrap) progressWrap.style.display = "none";
			if (stockMsg)
				stockMsg.innerHTML =
					'<p class="atq-availability-message-soldout">This product is sold out</p>';
		}

		// 4. Status de Disponibilidade na Caixa Informativa
		const availStatus = document.getElementById(
			"atq-product-availability-status"
		);
		if (availStatus) {
			if (isAvailable) {
				if (qty <= 0 && policy === "continue") {
					availStatus.innerHTML =
						'<span itemprop="available" class="product-available"> Available on Backorder </span>';
				} else {
					availStatus.innerHTML =
						'<span itemprop="available" class="product-available"> Product available </span>';
				}
			} else {
				availStatus.innerHTML =
					'<span itemprop="available" class="product-notavailable"> Out of Stock </span>';
			}
		}

		// 5. Imagem da Vitrine (Galeria)
		const variantImageId =
			selectedOption.getAttribute("data-image-id") ||
			(invData ? invData.featured_media_id : "");
		if (variantImageId && mediaArray.length > 0) {
			const targetIndex = mediaArray.findIndex(
				(media) => String(media.id) === String(variantImageId)
			);
			if (targetIndex !== -1) {
				updateMainImage(targetIndex);
			}
		}
	}

	if (variantSelect) {
		variantSelect.addEventListener("change", function () {
			const selectedOption = this.options[this.selectedIndex];
			updateATQVariantDetails(selectedOption);
		});

		if (window.jQuery) {
			window.jQuery(variantSelect).on("change", function () {
				const selectedOption = this.options[this.selectedIndex];
				updateATQVariantDetails(selectedOption);
			});
		}

		// Dispara a atualização inicial
		if (variantSelect.options && variantSelect.selectedIndex >= 0) {
			updateATQVariantDetails(
				variantSelect.options[variantSelect.selectedIndex]
			);
		}
	}

	// REPLACE the existing document.addEventListener("change"...) at the bottom with this:
	document.addEventListener("change", function (e) {
		if (!e.target) return;

		if (e.target.id === "productSelect" && e.target.options.length > 0) {
			// Simple product — #productSelect still has options (no option_selection.js conflict)
			const selectedOption = e.target.options[e.target.selectedIndex];
			if (selectedOption) updateATQVariantDetails(selectedOption);
		} else if (e.target.classList.contains("single-option-selector")) {
			// Variable product — option_selection.js emptied #productSelect
			// Match selected title(s) against window.variantInventories
			const productSOS = Array.from(
				document.querySelectorAll(".single-option-selector")
			).filter(
				(s) => s.id !== "collection-option" && s.name !== "collection"
			);

			const selectedTitle = productSOS.map((s) => s.value).join(" / ");

			if (window.variantInventories) {
				const matched = Object.values(window.variantInventories).find(
					(v) => v.title === selectedTitle
				);
				if (matched) updateATQFromInventoryData(matched);
			}
		}
	});

	// NEW helper — drives all UI updates from variantInventories data directly
	function updateATQFromInventoryData(invData) {
		if (!invData) return;

		// Price
		const priceEl = document.getElementById("atq-product-price");
		if (priceEl) priceEl.textContent = invData.price;

		// SKU
		const skuEl = document.getElementById("atq-product-sku");
		const skuWrapper = document.getElementById("atq-sku-wrapper");
		if (skuEl) {
			skuEl.textContent = invData.sku || "";
			if (skuWrapper) skuWrapper.style.display = invData.sku ? "" : "none";
		}

		// Stock bar & message
		const qty = invData.inventory_quantity;
		const policy = invData.inventory_policy;
		const isAvailable = invData.available;

		const qtyBar = document.getElementById("atq-qty-bar");
		const qtyVal = document.getElementById("atq-quantity");
		const progressWrap = document.getElementById("atq-progress-wrapper");
		const stockMsg = document.getElementById("atq-stock-message");

		if (qtyVal) qtyVal.textContent = qty;

		if (isAvailable && qty > 0) {
			if (qtyBar) qtyBar.style.display = "";
			if (progressWrap) progressWrap.style.display = "";
			if (stockMsg) stockMsg.innerHTML = "";
		} else if (policy === "continue") {
			if (qtyBar) qtyBar.style.display = "none";
			if (progressWrap) progressWrap.style.display = "none";
			if (stockMsg)
				stockMsg.innerHTML =
					'<p class="atq-availability-quantity">This product is available on backorder</p>';
		} else {
			if (qtyBar) qtyBar.style.display = "none";
			if (progressWrap) progressWrap.style.display = "none";
			if (stockMsg)
				stockMsg.innerHTML =
					'<p class="atq-availability-message-soldout">This product is sold out</p>';
		}

		// Availability status badge
		const availStatus = document.getElementById(
			"atq-product-availability-status"
		);
		if (availStatus) {
			if (isAvailable) {
				availStatus.innerHTML =
					qty <= 0 && policy === "continue"
						? '<span itemprop="available" class="product-available"> Available on Backorder </span>'
						: '<span itemprop="available" class="product-available"> Product available </span>';
			} else {
				availStatus.innerHTML =
					'<span itemprop="available" class="product-notavailable"> Out of Stock </span>';
			}
		}

		// Gallery image
		if (invData.featured_media_id && mediaArray.length > 0) {
			const targetIndex = mediaArray.findIndex(
				(m) => String(m.id) === String(invData.featured_media_id)
			);
			if (targetIndex !== -1) updateMainImage(targetIndex);
		}
	}
});
